import { SB } from '@play-co/replicant';

export const shopBundlesSchema = {
  shopBundles: SB.object({
    starterPackPurchased: SB.boolean().optional(),
    petStarterPackPurchased: SB.boolean().optional(),
    petStarterPackStartedAt: SB.int().optional(),
  }).optional(),
};
